import React from 'react';
import { Link } from 'react-router-dom';

import logoImg from '../../assets/dhobara-logo.png';
import css from './DhobaraFooter.module.css';

const IconInstagram = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="20"
    height="20"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" fill="none" />
    <circle cx="12" cy="12" r="4" fill="none" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const IconTikTok = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="20"
    height="20"
  >
    <path d="M20 8a5 5 0 0 0-8-4V16a4 4 0 1 1-4-4" />
  </svg>
);

const FOOTER_LINKS_SELLING = [
  { label: 'Sell with us', href: '/dashboard' },
  { label: 'How it Works', href: '/how-it-works' },
  { label: 'Seller Terms & Conditions', href: '/seller-terms' },
  { label: 'Pricing & payouts', href: '/seller-terms' },
  { label: 'Designers We Accept', href: '/designers' },
];

const FOOTER_LINKS_BUYING = [
  { label: 'How it works', href: '/how-it-works' },
  { label: 'Browse designers', href: '/designers' },
  { label: 'Buyer Protection', href: '/returns' },
  { label: 'Shipping', href: '/shipping' },
  { label: 'Return Policy', href: '/returns' },
];

const FOOTER_LINKS_COMPANY = [
  { label: 'About Us', href: '/why-dhobara' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact us', href: '/contact' },
];

/**
 * DhobaraFooter — the same footer used on the homepage (Selling / Buying / Company
 * link columns + brand block), reused on every other Dhobara-branded page so the
 * footer is consistent site-wide instead of falling back to the generic
 * Sharetribe-configured FooterContainer.
 */
const DhobaraFooter = () => (
  <footer className={css.footer}>
    <div className={css.footerMain}>
      <div>
        <span className={css.footerHeading}>Selling</span>
        <ul className={css.footerLinks}>
          {FOOTER_LINKS_SELLING.map(l => (
            <li key={l.label}>
              <Link to={l.href}>{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div className={css.footerCenter}>
        <span className={css.footerHeading}>Buying</span>
        <ul className={css.footerLinks}>
          {FOOTER_LINKS_BUYING.map(l => (
            <li key={l.label}>
              <Link to={l.href}>{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <span className={css.footerHeading}>Company</span>
        <ul className={css.footerLinks}>
          {FOOTER_LINKS_COMPANY.map(l => (
            <li key={l.label}>
              <Link to={l.href}>{l.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className={css.footerDivider} />
    <div className={css.footerBottom}>
      <div className={css.footerBottomLeft}>
        <img src={logoImg} alt="Dhobara" className={css.footerLogo} />
        <p className={css.footerDisclaimer}>
          Dhobara is an independent resale marketplace. All brand names and logos are trademarks
          of their respective owners. Dhobara is not affiliated with or endorsed by any of the
          brands listed.
        </p>
        <span className={css.footerCopy}>© {new Date().getFullYear()} Dhobara</span>
      </div>
      <div className={css.footerBottomRight}>
        <div className={css.footerSocials}>
          <a
            href="https://www.instagram.com/dhobara_store/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className={css.footerInstagram}
          >
            <IconInstagram />
          </a>
          <a
            href="https://www.tiktok.com/@dhobara_store?is_from_webapp=1&sender_device=pc"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            className={css.footerInstagram}
          >
            <IconTikTok />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default DhobaraFooter;
